// const PROXY = 'https://bam-cors-anywhere.herokuapp.com/';
// const BASE_URL = "https://ieknet.iek.org.tw/WebAPI";
// const LATEST_ARTICLE_URL = "/GetDomainLatest.aspx";
// const FEATURE_NEWS_URL = "/GetDomainFeatured.aspx";
// const POPULAR_ARTICLE_URL = "/GetDomainPopular.aspx";

const PROXY = '';
const BASE_URL = '';
const LATEST_ARTICLE_URL = './GetLatestArticle.aspx';
const FEATURE_NEWS_URL = './GetFeaturedNews.aspx';
const POPULAR_ARTICLE_URL = './GetPopularArticle.aspx';


const HEADERS = {
  "Content-Type": "application/json",
  "Access-Control-Allow-Origin": "*",
};
const PARAMS = {
  query_id: "774f5cdbcfdf4172988eb4402c66e5c1",
  system: "AI Zone",
  zoneid: "82",
};

// 最新文章
export async function getLatestArticle() {
  const response = await fetch(PROXY + BASE_URL + LATEST_ARTICLE_URL, {
    method: "POST",
    mode: "no-cors",
    headers: HEADERS,
    body: JSON.stringify(PARAMS),
  });
  const result = await response.json();

  return result;
}

// 精選新聞
export async function getFeatureNews() {
  const response = await fetch(PROXY + BASE_URL + FEATURE_NEWS_URL, {
    method: "POST",
    headers: HEADERS,
    body: JSON.stringify(PARAMS),
  });
  const result = await response.json();

  return result;
}

// 熱門點閱
export async function getPopularArticle() {
  const response = await fetch(PROXY + BASE_URL + POPULAR_ARTICLE_URL, {
    method: "POST",
    headers: HEADERS,
    body: JSON.stringify(PARAMS),
  });
  const result = await response.json();

  return result;
}
